import * as numeral from 'numeral';
import deepmerge from 'deepmerge';
const isArray = Array.isArray;

const ts = Date.now();
let uidCounter = 1;

const emptyTarget = value => (Array.isArray(value) ? [] : {});
const clone = (value, options) => deepmerge(emptyTarget(value), value, options);

function oldArrayMerge(target, source, options) {
  const destination = target.slice();

  source.forEach(function (e, i) {
    if (typeof destination[i] === 'undefined') {
      const cloneRequested = options.clone !== false;
      const shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? clone(e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}

const isBig = function (n, ...args) {
  let isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
  args.push(n);
  return args.every(item => isValid.test((item += '')));
};

/**
 * 调试模式开关
 * 用法：url末尾增加“?debug=1767”可打开调试模式。用于生产环境快速定位bug。
 **/
let isDebug = false;
if (window && typeof URLSearchParams === 'function') {
  let queryString = window.location.search; //'?debug=1767'
  let params = new URLSearchParams(queryString);
  isDebug = params.get('debug') === '1767';
  if (isDebug) {
    console.log('Util 调试模式已打开');
  }
}

const Util = {
  debug(...args) {
    if (isDebug && console) {
      console.log.apply(console, args);
    }
  },

  //生成唯一ID
  genUid: function (prefix = 'uid') {
    let uid = prefix + ts + uidCounter;
    uidCounter += 1;
    return uid;
  },

  merge: function (x, y) {
    return deepmerge(x, y, { arrayMerge: oldArrayMerge });
  },

  mergeAll: function (arr) {
    return deepmerge.all(arr, { arrayMerge: oldArrayMerge });
  },

  clone: function (obj) {
    return this.merge({}, obj);
  },

  isObj: function (obj) {
    return obj === Object(obj);
  },

  //url增加params
  addParams: function (url = '', params = {}) {
    if (!this.isObj(params) || this.isEmpty(params)) {
      return url;
    }
    let strParams = Object.keys(params)
      .map(key => {
        return key + '=' + params[key];
      })
      .join('&');
    let connector = url.indexOf('?') === -1 ? '?' : '&';
    return url + connector + strParams;
  },

  precisionRound: function (number, precision) {
    var shift = function (num, exponent) {
      var numArray = ('' + num).split('e');
      return +(
        numArray[0] +
        'e' +
        (numArray[1] ? +numArray[1] + exponent : exponent)
      );
    };
    return shift(Math.round(shift(number, +precision)), -precision);
  },

  routeTitleTransform: function (title) {
    return title
      .replace(/\s+/g, '-')
      .toLowerCase()
      .replace(/[^0-9a-z-]+/g, '');
  },

  isSet: function (s, obj) {
    var n, arr, o;
    if (typeof s === 'string') {
      arr = s.split('.');
      o = obj;
      for (n = 0; n < arr.length; n += 1) {
        if (o[arr[n]] === undefined || o[arr[n]] === null) {
          return false;
        } else {
          o = o[arr[n]];
        }
      }
      return true;
    }
    throw new Error('Missing or invalid argument passed to isSet');
  },

  isEmpty: function (o, ...args) {
    args.push(o);
    function _isEmpty(obj) {
      switch (typeof obj) {
        case 'undefined':
          return true;
        case 'string':
          return obj.trim().length === 0;
        case 'object':
          if (Array.isArray(obj)) {
            return obj.length === 0;
          } else if (obj === null) {
            return true;
          } else if (Object.keys(obj).length === 0) {
            return true;
          }
          break;
        case 'number':
          if (isNaN(obj)) {
            return true;
          }
          break;
        default:
          return false;
      }
    }
    return args.some(item => _isEmpty(item));
  },

  //处理日期范围
  parseDateRange(range) {
    if (Array.isArray(range)) {
      return [range[0], range[1] + 24 * 60 * 60 * 1000 - 1]; //endTime设置为每天最后1毫秒
    }
    return [undefined, undefined];
  },

  //封装JSON.parse,避免异常报错
  jsonDecode(json) {
    let obj = null;
    try {
      obj = JSON.parse(json);
    } catch (err) {
      //todo
    }
    return obj;
  },

  //使用big.js计算前判断数字或字符串是否合法运算值
  // isBig: function (n, ...args) {
  //   let isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
  //   args.push(n);
  //   return args.every(item => isValid.test((item += '')));
  // },

  isBig: isBig,

  // big运算前检查合法性，如果不合法用0代替
  formatBig(qty) {
    return isBig(qty) ? qty : 0;
  },

  //复制schema中选定的属性  schema支持属性名转换： ['name', ['age', 'vAge']]
  copyPropsBySchema: function (target, source, schema) {
    if (this.isObj(target) && this.isObj(source) && Array.isArray(schema)) {
      schema.forEach(function (prop) {
        let sourceProp, targetProp;
        if (typeof prop === 'string') {
          sourceProp = targetProp = prop;
        } else {
          sourceProp = prop[0];
          targetProp = prop[1];
        }
        if (typeof source[sourceProp] !== undefined) {
          target[targetProp] = source[sourceProp];
        }
      });
      return target;
    } else {
      throw new Error(
        'Missing or invalid argument passed to copyPropsBySchema'
      );
    }
  },

  //复制列表中对象选定的属性,返回新数组
  copyArrayBySchema: function (source, schema) {
    var result = [];
    var self = this;
    if (Array.isArray(source) && Array.isArray(schema)) {
      source.forEach(function (item) {
        var obj = {};
        self.copyPropsBySchema(obj, item, schema);
        result.push(obj);
      });
      return result;
    }
    throw new Error('Missing or invalid argument passed to copyArrayBySchema');
  },

  getParamObj: function (strParams) {
    var o = {};
    strParams = typeof strParams === 'string' ? strParams : '';
    strParams.replace(/([^?=&]+)=([^&]*)/g, function (m, key, value) {
      o[key] = value;
    });
    return o;
  },

  //提交数据时需要把经过checkbox转换过的布尔值再转换回来
  transformBoolToInt: function (obj, schema = []) {
    if (this.isObj(obj)) {
      schema.forEach(function (prop) {
        if (typeof obj[prop] === 'boolean') {
          obj[prop] = obj[prop] ? 1 : 0;
        }
      });
      return obj;
    } else {
      throw new Error(
        'Missing or invalid argument passed to transformBoolToInt'
      );
    }
  },

  //格式化文件大小
  renderSize: function (value) {
    if (null === value || value === '') {
      return '0 Bytes';
    }
    let unitArr = ['Bytes', 'KB', 'MB'];
    let index = 0;
    let srcsize = parseFloat(value);
    index = Math.floor(Math.log(srcsize) / Math.log(1024));
    let size = srcsize / Math.pow(1024, index);
    size = size.toFixed(1);
    return size + unitArr[index];
  },

  //格式化金额
  transform(n, format) {
    if (n === undefined) {
      return '***';
    }
    let v = numeral(n).format(format);
    return v;
  },

  dateFormat: function (value, fmt = 'mediumDate') {
    if (value === null || value === '' || value !== value) {
      value = new Date().getTime();
    }
    if (typeof value === 'string') {
      value = parseFloat(value.trim());
    }
    var d = new Date(value);
    var o = {
      'M+': d.getMonth() + 1, //月份
      'd+': d.getDate(), //日
      'h+': d.getHours(), //小时
      'm+': d.getMinutes(), //分
      's+': d.getSeconds(), //秒
      'q+': Math.floor((d.getMonth() + 3) / 3), //季度
      S: d.getMilliseconds(), //毫秒
    };
    if (fmt === '年月日') {
      return d.getFullYear() + '年' + o['M+'] + '月' + o['d+'] + '日';
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (d.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  },

  IEVersion: function () {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE =
      userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; //判断是否IE（小于IE11）
    var isEdge = userAgent.indexOf('Edge') > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 =
      userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
    if (isIE) {
      var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp['$1']);
      if (fIEVersion === 7) {
        return 7;
      } else if (fIEVersion === 8) {
        return 8;
      } else if (fIEVersion === 9) {
        return 9;
      } else if (fIEVersion === 10) {
        return 10;
      } else {
        return 6;
      }
    } else if (isEdge) {
      return 'edge';
    } else if (isIE11) {
      return 11;
    } else {
      return -1; //不是ie浏览器
    }
  },

  changeMoneyToChinese: function (money) {
    var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']; //汉字的数字
    var cnIntRadice = ['', '拾', '佰', '仟']; //基本单位
    var cnIntUnits = ['', '万', '亿', '兆']; //对应整数部分扩展单位
    var cnDecUnits = ['角', '分', '毫', '厘']; //对应小数部分单位
    var cnInteger = '整'; //整数金额时后面跟的字符
    var cnIntLast = '元'; //整型完以后的单位
    var maxNum = 999999999999999.9999; //最大处理的数字

    var IntegerNum; //金额整数部分
    var DecimalNum; //金额小数部分
    var ChineseStr = ''; //输出的中文金额字符串
    var parts; //分离金额后用的数组，预定义
    if (money === '') {
      return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
      console.log('超出最大处理数字');
      return '';
    }
    if (money === 0) {
      ChineseStr = cnNums[0] + cnIntLast;
      return ChineseStr;
    }
    money = money.toString(); //转换为字符串
    if (money.indexOf('.') === -1) {
      IntegerNum = money;
      DecimalNum = '';
    } else {
      parts = money.split('.');
      IntegerNum = parts[0];
      DecimalNum = parts[1].substr(0, 4);
    }
    if (parseInt(IntegerNum, 10) > 0) {
      //获取整型部分转换
      let zeroCount = 0;
      let IntLen = IntegerNum.length;
      for (let i = 0; i < IntLen; i++) {
        var n = IntegerNum.substr(i, 1);
        var p = IntLen - i - 1;
        var q = p / 4;
        var m = p % 4;
        if (n === '0') {
          zeroCount += 1;
        } else {
          if (zeroCount > 0) {
            ChineseStr += cnNums[0];
          }
          zeroCount = 0; //归零
          ChineseStr += cnNums[parseInt(n, 10)] + cnIntRadice[m];
        }
        if (m === 0 && zeroCount < 4) {
          ChineseStr += cnIntUnits[q];
        }
      }
      ChineseStr += cnIntLast;
      //整型部分处理完毕
    }
    if (DecimalNum !== '') {
      //小数部分
      let decLen = DecimalNum.length;
      for (let i = 0; i < decLen; i++) {
        n = DecimalNum.substr(i, 1);
        if (n !== '0') {
          ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
        }
      }
    }
    if (ChineseStr === '') {
      ChineseStr += cnNums[0] + cnIntLast;
    } else if (DecimalNum === '') {
      ChineseStr += cnInteger;
    }
    return ChineseStr;
  },

  //字符串的字节长度
  getStrLength: function (str) {
    var text = str.replace(/[^\x00-\xff]/g, '**');
    return text.length;
  },

  //截取字符
  getShortForm: function (str, len = 0, alt = '...') {
    if (len > 0 && this.getStrLength(str) > len) {
      var i = 0;
      for (var z = 0; z < len; z++) {
        if (str.charCodeAt(z) > 255) {
          i = i + 2;
        } else {
          i = i + 1;
        }
        if (i >= len) {
          str = str.slice(0, z + 1) + alt;
          break;
        }
      }
      return str;
    } else {
      return str + '';
    }
  },

  getBase64FromImageUrl: function (URL, callBack) {
    //URL为false 或 IE浏览器时回调的值为1px的透明图片
    if (!URL || Util.IEVersion() !== -1) {
      if (callBack) {
        callBack(
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABBJREFUeNpi+P//PwNAgAEACPwC/tuiTRYAAAAASUVORK5CYII='
        );
      }
      return;
    }
    var img = new Image();

    //设置跨域，需服务端同步设置“*”
    if (URL.indexOf('http') > -1) {
      img.setAttribute('crossOrigin', 'anonymous');
      URL = URL + '?v529';
    }

    img.src = URL;
    img.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL('image/png');
      //dataURL = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
      if (callBack) {
        callBack(dataURL);
      }
    };
  },

  /* 列表相关方法 begin */

  //列表排序
  listSort: function (list, orderProperty, ascOrDesc) {
    if (list.length < 2) {
      return list;
    }
    let obj = {};
    let arrVal = [];
    list.forEach((row, i) => {
      let key = row[orderProperty] + '_' + i;
      arrVal.push(key);
      obj[key] = row;
    });
    arrVal.sort();
    if (ascOrDesc === 'desc') {
      arrVal.reverse();
    }
    return arrVal.map(key => obj[key]);
  },

  //列表搜索（过滤）
  listSearch(list, searchKey, arrField) {
    return list.filter(item => {
      if (typeof searchKey !== 'string' || searchKey === '') {
        return true;
      } else {
        return arrField.some(field => {
          if (typeof item[field] !== 'string') {
            return false;
          }
          let key = searchKey.trim().toLowerCase();
          let value = item[field].toLowerCase();
          return value.indexOf(key) !== -1;
        });
      }
    });
  },

  //生成前端分页数据
  genListPage(list, pageNum, pageSize) {
    let totalNum = list.length;
    let begin = (pageNum - 1) * pageSize;
    let end = Math.min(pageNum * pageSize, totalNum);
    return list.slice(begin, end);
  },

  /* 列表相关方法 end */

  //生成打印用的合同条款数据
  genContractualClauseData(data) {
    let ret = [];
    data = data.replace(/\r\n/g, '<br/>');
    data = data.replace(/\n/g, '<br/>');
    data = data.replace(/\s/g, ' ');
    data = data.split('<br/>');
    data.forEach(item => {
      ret.push({
        text: item,
        style: 'barcodeHead',
      });
    });
    return ret;
  },

  /**
   * 生成订单扩展字段信息（采购说明）
   *
   * @param poLine: any  订单单身
   */
  genExtendFields(poLine) {
    if (!poLine) {
      return;
    }
    let extendFields = [];
    let printExtendFields = '';
    if (typeof poLine.fieldsShow === 'string') {
      let obj = Util.jsonDecode(poLine.fieldsShow);
      if (obj !== null) {
        for (let key in obj) {
          let value = poLine[key];
          if (value !== null) {
            extendFields.push({
              key: obj[key],
              value,
            });
            printExtendFields += obj[key] + '：' + value + '；';
          }
        }
      }
    }
    poLine.extendFields = extendFields;
    poLine.printExtendFields = printExtendFields;
  },

  //数量变化(keyup)
  qtyChange(value) {
    if (/^-?\d*(\.\d*)?$/.test(value) === false || value === '.') {
      //允许 '', '5.' 以方便用户输入
      value = 0;
    }
    return value;
  },

  //数量字段失去焦点(change)
  qtyBlur(value) {
    if (typeof value === 'number') {
      return value;
    }
    if (/^-?\d+\.?$/.test(value) === true) {
      value = value.replace('.', '');
    }
    if (value === '' || value === undefined) {
      value = 0;
    }
    return value;
  },

  //页面路由地址过长,使用hash做为key.(Djb2)
  getHashKey(text) {
    let hash = 5381,
      index = text.length;
    while (index) {
      index -= 1;
      hash = (hash * 33) ^ text.charCodeAt(index);
    }
    return (hash >>> 0).toString(16);
  },

  /**
   * 获取去重后数组
   *
   * @param arr
   * @returns unique
   */
  getUnique(arr) {
    if (isArray(arr)) {
      let unique = [];
      arr.forEach(item => {
        if (!unique.includes(item)) {
          unique.push(item);
        }
      });
      return unique;
    } else {
      throw new Error('Missing or invalid argument passed to isDuplicated');
    }
  },

  /**
   * 数组是否包含重复数据
   *
   * @param arr
   * @returns {boolean} new array
   */
  isDuplicated(arr) {
    if (isArray(arr)) {
      return arr.length !== this.getUnique(arr).length;
    } else {
      throw new Error('Missing or invalid argument passed to isDuplicated');
    }
  },
};

export default Util;
